module.exports = __webpack_public_path__ + "static/img/14000694.aabe0a2f.png";